import naturalCompare from 'natural-compare';
import { SelectProps } from '@amzn/awsui-components-core';
import {
  AWSService,
  ContentQualityResponseOptions,
  TechDomain,
  TechDomainDisplayNames,
} from '@amzn/awscat-pattern-library-service-model';
import {
  awsServiceDisplayNames,
  responseOptionsDisplayNames,
  yearsOfExperienceDisplayNames,
} from './DisplayNames';
import { YearsOfExperience } from '@amzn/awscat-pattern-library-service-model';

// TODO: Merge this file with SelectableOptions.ts and update all related files to using Polaris v3.

export const naturalSort = (l: SelectProps.Option[]) =>
  // @ts-expect-error TS18048 - strict migration
  l.sort((a, b) => naturalCompare(a.label.toLowerCase(), b.label.toLowerCase()));

export const doNotSort = (l: SelectProps.Option[]) => l;

export const createFromEnum = (
  e: { [i: number]: string },
  m: Map<string, string>,
  excludes = [],
  sortFn = naturalSort,
): SelectProps.Option[] => {
  return sortFn(
    Object.keys(e)
      .map((k) =>
        // @ts-expect-error TS2345 - strict migration
        Array.isArray(excludes) && excludes.includes(e[k])
          ? null
          : {
              label: m.get(k) || k,
              value: k,
            },
      )
      .filter((v) => !!v),
  );
};

export const TechDomainOptions: SelectProps.Option[] = createFromEnum(
  TechDomain,
  TechDomainDisplayNames,
  // @ts-expect-error TS2322 - strict migration
  [TechDomain.NotApplicable],
);

export const AWSServiceOptions: SelectProps.Option[] = createFromEnum(
  AWSService,
  awsServiceDisplayNames,
);

export const YearsOfExperienceOptions: SelectProps.Option[] = createFromEnum(
  YearsOfExperience,
  yearsOfExperienceDisplayNames,
  [],
  doNotSort,
);

// @ts-expect-error TS7006 - strict migration
export const getResponseOptions = (excludes?): SelectProps.Option[] =>
  createFromEnum(ContentQualityResponseOptions, responseOptionsDisplayNames, excludes, doNotSort);
